import * as React from 'react'
import { Link } from 'gatsby'

import Page from '../components/Page'
import Container from '../components/Container'
import IndexLayout from '../layouts'

const IndexPage = () => (
  <IndexLayout>
    <Page>
      <Container>
        <h1>Hi people</h1>
        <p>Welcome to your new Gatsby site.</p>
        <p>Now go build something great.</p>
        <p>
          <Link to="/page-2/">Go to page 2</Link>.
        </p>
        <p>
          <Link to="/html/">View a HTML test page</Link>.
        </p>
        <p>
          <Link to="/markdown/">View a markdown test page</Link>.
        </p>
      </Container>
    </Page>
  </IndexLayout>
)

export default IndexPage
